import React from "react";
import './Blocs.scss';
import Utils from 'utils/Utils';

function BlocTexte({item}) {
  const {texte} = item || {};
  return texte ? <div className="bloc bloc-texte">{Utils.parseWithLinks(texte)}</div> : '';
}
export default BlocTexte;
